export class AuthService {
  private static get clientId(): string {
    const value = process.env.NEXT_PUBLIC_CLIENT_ID;
    if (!value) throw new Error('Missing NEXT_PUBLIC_CLIENT_ID');
    return value;
  }

  private static get redirectUri(): string {
    const value = process.env.NEXT_PUBLIC_REDIRECT_URI;
    if (!value) throw new Error('Missing NEXT_PUBLIC_REDIRECT_URI');
    return value;
  }

  private static get domain(): string {
    const value = process.env.NEXT_PUBLIC_DOMAIN;
    if (!value) throw new Error('Missing NEXT_PUBLIC_DOMAIN');
    return value;
  }

  private static providers = {
    google: 'Google',
    facebook: 'Facebook',
    apple: 'SignInWithApple',
  };

  private static getProvider(providerKey: keyof typeof this.providers): string {
    const value = this.providers[providerKey];
    if (!value) throw new Error(`Invalid provider key: ${providerKey}`);
    return value;
  }

  static buildOAuthUrl(provider: string): string {
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: this.clientId,
      redirect_uri: this.redirectUri,
      identity_provider: provider,
      scope: 'aws.cognito.signin.user.admin email openid phone profile',
      prompt:'select_account'
    });

    return `${this.domain}/oauth2/authorize?${params.toString()}`;
  }

  static initiateOAuth(provider: string): void {
    const url = this.buildOAuthUrl(provider);
    window.location.href = url;
  }

  static loginWithGoogle = (): void => {
    const provider = this.getProvider('google');
    this.initiateOAuth(provider);
  };

  static loginWithFacebook = (): void => {
    const provider = this.getProvider('facebook');
    this.initiateOAuth(provider);
  };

  static loginWithApple = (): void => {
    const provider = this.getProvider('apple');
    this.initiateOAuth(provider);
  };
}
